import React from 'react'
import { SDG_IMAGES } from '../../../constants/datas';
import AvatarImage from '../../../ui/AvatarImage';
import BountyDescription from '../../bounties/BountyDescription';
import { EarthIcon, FistIcon, SunIcon, WaterIcon } from '../../../assets/icons/ProgressBarIcons';
import BountyDescriptionInCard from '../../bounties/BountyDescriptionInCard';

const coreIcons = {
    Earth: <EarthIcon key="earth-icon" color="" />,
    Energy: <SunIcon key="sun-icon" color="" />,
    Social: <FistIcon key="fist-icon" color="" />,
    Water: <WaterIcon key="wayer-icon" color="" />,
  };
const ActivityUnderProject = ({activity,isFull=false}) => {
  
  return (
    <div className={`container ${isFull ? "" : "min-w-[32.5rem]"} flex flex-col gap-[.375rem] rounded-lg px-5 bg-grayBgNormal py-4 mr-5 overflow-hidden`} style={!isFull ? {width: '32.5rem'} : {}}>
      <div className={`${isFull ? "w-full" : ""} flex  flex-col gap-4 `}>
        <div className="overflow-hidden">
          <h3 className='text-textPrimary font-medium truncate'>{activity?.title}</h3>
          <BountyDescriptionInCard 
            htmlClassName="prose text-textPrimary word-wrap mt-1 text-sm max-w-none [&_p:empty]:before:content-['\\00a0'] [&_p:empty]:inline-block overflow-hidden" 
            paragraphClassName='text-textPrimary mt-1 text-sm word-wrap overflow-hidden' 
            html={activity?.description} 
            forceThreeLines={true} 
          />
        </div>
        
        <div className='flex flex-col gap-5'>
          <div className='grid grid-cols-3 min-w-0'>
            <div className="col-span-1">
              <p className="text-textSecondary text-sm font-medium">Impact Cores</p>
              <div className="flex items-center">
                {activity?.cores?.map((core) => coreIcons[core])}
              </div>
            </div>
            <div className="col-span-2">
              <p className="text-textSecondary text-sm font-medium">SDGs</p>
              <div className="flex flex-wrap gap-[.2325rem] max-w-full overflow-hidden">
                {activity?.SDGs?.map((sdg, index) => (
                  <img key={sdg + index} className="w-[2.75rem] h-[2.9375rem] flex-shrink-0" src={SDG_IMAGES[sdg]} alt="" />
                ))}
              </div>
            </div>
           
          </div>
          
          <div className='grid grid-cols-3'>
          <div className='col-span-1'>
              <p className="text-textSecondary text-sm mb-1 font-medium">Created By</p>
              <div className="flex items-center gap-2">
                <AvatarImage url={activity?.creator?.profileImage} w='w-5' h='h-5'/>
                <span className="text-sm text-textPrimary truncate">{activity?.creator?.username}</span>
              </div>
            </div>
            <div className='col-span-2'>
              <p className="text-textSecondary mb-1 text-sm font-medium">Validated By</p>
              { activity?.validators?.length > 0 ? (
                <div className="flex items-center gap-2">
                  <AvatarImage 
                    w='w-5' 
                    h='h-5'
                    url={activity.validators[0]?.profileImage}
                  />
                  <span className="text-sm text-textPrimary truncate">
                    {activity.validators[0]?.username}
                    {activity.validators.length > 1 && ` + ${activity.validators.length - 1} more`}
                  </span>
                </div>
              ) : (
                <div className="opacity-0 flex items-center gap-2">
                  <AvatarImage w='w-5' h='h-5'/>
                  <span className="text-sm text-textPrimary">username</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default ActivityUnderProject